import { useState } from 'react';
import DashboardPage from './DashboardPage';
import { ChannelNavBar, Team } from './components/ChannelNavBar';

function App() {
  // Initialize currentTeam state as an empty string.
  // The dashboard will not render until this is set.
  const [currentTeam, setCurrentTeam] = useState<Team>('');

  // This function will be called by ChannelNavBar once it fetches the channels.
  const handleChannelsFetched = (channels: Team[]) => {
    // Set the first channel as the default active team,
    // but only if a team hasn't been selected yet.
    if (currentTeam === '' && channels.length > 0) {
      setCurrentTeam(channels[0]);
    }
  };

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      {/* ChannelNavBar now notifies App when channels are loaded */}
      <ChannelNavBar 
        currentTeam={currentTeam} 
        setCurrentTeam={setCurrentTeam}
        onChannelsFetched={handleChannelsFetched}
      />

      {/* Main content area */}
      <div className="flex-1 overflow-y-auto">
        {/* Conditionally render DashboardPage only when a currentTeam is set. */}
        {/* This prevents the dashboard from making API calls with an invalid team. */}
        {currentTeam ? (
          <DashboardPage currentTeam={currentTeam} />
        ) : (
          <div className="p-6 text-center text-gray-500">
            Selecting a channel...
          </div>
        )}
      </div>
    </div>
  );
}

export default App;